<div class="collaborators-container">

  <!-- ===== Top section: Collaborators ===== -->
  <div class="section-label">{{ 'COLLABORATORS' | translate }}</div>

  <div class="table-scroll">
    <table mat-table [dataSource]="collaboratorsDataSource" class="full-width">

      <!-- Role Column -->
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_ROLE' | translate }}</th>
        <td matTooltip="{{ element.roleName }}" mat-cell *matCellDef="let element">{{ element.roleName }}</td>
      </ng-container>

      <!-- Collaborator Column -->
      <ng-container matColumnDef="collaborator">
        <th mat-header-cell *matHeaderCellDef>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_COLLABORATOR' | translate
          }}</th>
        <td matTooltip="{{ element.name }}" mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_EMAIL' | translate }}</th>
        <td matTooltip="{{ element.email }}" mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>

      <!-- Access Column -->
      <ng-container matColumnDef="access">
        <th mat-header-cell *matHeaderCellDef>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_ACCESS' | translate }}
        </th>
        <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
          <mat-slide-toggle color="primary" [checked]="element.canEdit" (toggleChange)="toggleAccess(element)">
            {{ (element.canEdit ? 'EDIT' : 'VIEW') | translate }}
          </mat-slide-toggle>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="collaboratorsColumns" class="row-height"></tr>
      <tr mat-row *matRowDef="let row; columns: collaboratorsColumns;" (click)="onCollaboratorRowClick(row)"
        [class.selected]="collaboratorsSelection.isSelected(row)" class="row-height">
      </tr>
    </table>
  </div>

  <!-- ===== Add / Remove buttons ===== -->
  <div class="action-buttons">
    <button mat-raised-button color="primary" [disabled]="!isAddEnabled" (click)="addToCollaborators()">
      {{ 'ADD' | translate }} <mat-icon>arrow_upward</mat-icon>
    </button>
    <button mat-raised-button color="primary" [disabled]="!isRemoveEnabled" (click)="removeFromCollaborators()">
      {{ 'REMOVE' | translate }} <mat-icon>arrow_downward</mat-icon>
    </button>
  </div>

  <!-- ===== Bottom section: Available Collaborators ===== -->
  <div class="section-label">{{ 'AVAILABLE_COLLABORATORS' | translate }}</div>

  <div class="table-scroll">
    <table mat-table [dataSource]="availableDataSource" class="full-width">

      <!-- Role Column -->
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_ROLE' | translate }}</th>
        <td matTooltip="{{ element.roleName }}" mat-cell *matCellDef="let element">{{ element.roleName }}</td>
      </ng-container>

      <!-- Collaborator Column -->
      <ng-container matColumnDef="collaborator">
        <th mat-header-cell *matHeaderCellDef>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_COLLABORATOR' | translate
          }}</th>
        <td matTooltip="{{ element.name }}" mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_EMAIL' | translate }}</th>
        <td matTooltip="{{ element.email }}" mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>

      <!-- Access Column -->
      <ng-container matColumnDef="access">
        <th mat-header-cell *matHeaderCellDef>{{ 'MENU_FILE_PROPERTIES_ESTIMATE_COLLABORATION_ACCESS' | translate }}
        </th>
        <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
          <mat-slide-toggle color="primary" [checked]="element.canEdit" (toggleChange)="toggleAccess(element)">
            {{ (element.canEdit ? 'EDIT' : 'VIEW') | translate }}
          </mat-slide-toggle>
        </td>
      </ng-container>

      <!-- Delete (Cross) Column -->
      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="availableSelection.isSelected(element)" class="delete-icon" mat-icon-button color="warn"
            (click)="deleteAvailableCollaborator(element); $event.stopPropagation()">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="availableColumns" class="row-height"></tr>
      <tr mat-row *matRowDef="let row; columns: availableColumns;" (click)="onAvailableRowClick(row)"
        [class.selected]="availableSelection.isSelected(row)" class="row-height">
      </tr>
    </table>
  </div>

  <!-- ===== Add Collaborator button ===== -->
  <div class="add-collaborator-btn">
    <button mat-raised-button color="primary" [disabled]="!isAddCollaboratorEnabled"
      (click)="addCollaborator()"><mat-icon>add</mat-icon>
      {{ 'ADD_COLLABORATOR' | translate }}
    </button>
  </div>

</div>